<template lang="pug">
div
  h3.page-title {{$route.meta.title}}

  component(:is="formContainer.component ? formContainer.component : 'el-card'" v-loading="isLoading")
    div.card-head(slot="header")
      el-button(type="primary" @click="Submit") 保 存
      el-button(@click="$router.go(-1)") 取 消
    div.card-body
      component.form(v-for="(form,index) of forms" :is="form.wrapComponent? form.wrapComponent : 'el-card'" v-bind="form.wrapAttrs" :key="index")
        template(#header v-if="form.name")
          | {{form.name}}
        common-form(
          ref="form"
          v-bind="form.attrs"
          :options="form.formInfo"
          :values="value"
          @onFormValueChange="onFormValueChange"
          )
</template>

<script>


export default {
  name: 'Form',
  data() {
    return {
      isLoading: false,
      formContainer: {},
      forms: [
        {
          wrapComponent: 'div',
          wrapAttrs: {
            gutter: 10
          },
          attrs: {
            labelWidth: '120px',
            labelPosition: 'left',
          },
          formInfo: [
            {
              name: '优化师',
              component: 'UserSelector',
              key: 'user',
              default: 0,
              attrs: {
                placeholder: '请选择优化师',
              },
              rules: [
                { required: true, message: '请选择优化师', trigger: 'blur' }
              ]
            },
            {
              name: 'SPU',
              component: 'SPUSelector',
              key: 'product',
              default: {
                chinese_name: ''
              },
              attrs: {
                placeholder: '请输入产品名称(外文)',
              },
              rules: [
                { required: true, message: '请输入产品名称(外文)', trigger: 'blur' }
              ]
            },
            {
              name: '落地页标题',
              component: 'el-input',
              key: 'title',
              default: '',
              attrs: {
                placeholder: '请输入产品名称(外文)',
              },
              rules: [
                { required: true, message: '请输入产品名称(外文)', trigger: 'blur' }
              ]
            },
            {
              name: '落地页描述',
              component: 'el-input',
              key: 'describe',
              default: '',
              attrs: {
                placeholder: '请输入产品名称(外文)',
              },
              rules: [
                { required: true, message: '请输入产品名称(外文)', trigger: 'blur' }
              ]
            },
            {
              name: '域名',
              component: 'el-input',
              key: 'domain_name',
              default: '',
              attrs: {
                placeholder: '',
              },
              rules: [
                // { required: true, message: '请输入产品名称(外文)', trigger: 'blur' }
              ]
            },
            {
              name: '二级目录',
              component: 'el-input',
              key: 'id',
              default: '',
              attrs: {
                disabled: true,
                placeholder: '自动生成',
              },
              rules: [
                // { required: true, message: '请输入产品名称(外文)', trigger: 'blur' }
              ]
            },
            {
              name: '选择地区',
              component: 'AreaSelect',
              key: 'id_poi_area',
              default: '',
              attrs: {
                placeholder: '选择地区',
              },
              rules: [
                { required: true, message: '选择地区', trigger: 'blur' }
              ]
            },
            {
              name: '选择语言',
              component: 'LanguageSelect',
              key: 'id_poi_language',
              default: '',
              attrs: {
                placeholder: '请选择语言',
              },
              rules: [
                { required: true, message: '请选择语言', trigger: 'blur' }
              ]
            },
            {
              name: '付款方式',
              component: 'CheckboxGroup',
              key: 'payment',
              default: [],
              attrs: {
                options: [
                  {
                    value: 0,
                    label: '货到付款'
                  },
                  {
                    value: 1,
                    label: '711商超取货'
                  },
                  {
                    value: 2,
                    label: '全家取货'
                  },
                ],
                placeholder: '请选择付款方式',
              },
              rules: [
                // { required: true, message: '请输入产品名称(外文)', trigger: 'blur' }
              ]
            },
            {
              name: '销量',
              component: 'el-input',
              key: 'sales_volume',
              default: '',
              attrs: {
                placeholder: '',
              },
              rules: [
                // { required: true, message: '', trigger: 'blur' }
              ]
            },
            {
              name: '库存',
              component: 'el-input',
              key: 'stock',
              default: 999
            },
            {
              name: '销售价格',
              component: 'el-input',
              key: 'sale_price',
              attrs: {
                placeholder: '请输入销售价格',
              },
              rules: [
                // { required: true, message: '请输入销售价格', trigger: 'blur' }
              ]
            },
            {
              name: '市场价',
              component: 'el-input',
              key: 'market_price',
              attrs: {
                placeholder: '请输入市场价',
              },
              rules: [
                // { required: true, message: '请输入市场价', trigger: 'blur' }
              ]
            },
            {
              name: '缩略图',
              component: 'Uploader',
              key: 'thumbnail_image',
              default: ''
            },
            {
              name: '图集',
              component: 'Uploader',
              key: 'atlas_image',
              attrs: {
                type: 'list',
                limit: 5
              },
              default: []
            },
            {
              name: '套餐',
              component: 'PackageSelector',
              key: 'package',
              default: []
            },
            {
              name: '落地页模板',
              component: 'el-input',
              key: 'style',
              default: '',
              attrs: {
                disabled: true,
                placeholder: '默认模板1'
              }
            },
            {
              name: 'FB通用像素id',
              component: 'el-input',
              key: 'pixel',
              default: '',
              attrs: {
                placeholder: '请输入FB通用像素id',
              },
              rules: [
                // { required: true, message: '请输入FB通用像素id', trigger: 'blur' }
              ]
            },
            {
              name: '内容',
              component: 'TinyEditor',
              key: 'content',
              default: '',
              attrs: {
                height: '60vh'
              },
              rules: [
                // { required: true, message: '请输入产品名称(外文)', trigger: 'blur' }
              ]
            },
          ]
        }
      ]
    }
  },
  computed: {
    value() {
      return this.$store.state.pageValue
    },
    viewType() {
      return this.$store.state.viewType
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    // 更新表单的attrs属性
    setFormAttr(index, key, attr) {
      let form = this.forms[index].formInfo
      let res = form.find((item) => {
        return item.key === key
      })
      if (res) {
        this.$set(res, 'attrs', attr)
      } else {
        console.log('没找到')
      }

    },
    // 表单值发生变化的回调
    onFormValueChange({item, value}) {
      // 地区发生变化的时候，同步更新语言
      if (item.key === 'id_poi_area') {
        this.$nextTick(() => {
          // 付款方式的改变
          if (value == 1) {
            this.$refs.form[0].form['payment'] = [0,1,2]
          }
          if (value != 1) {
            this.$refs.form[0].form['payment'] = [0]
          }

          // 语言的选择
          switch(value) {
            // 台湾和香港对应繁体中文
            case 1:
            case 4:
              this.$refs.form[0].form['id_poi_language'] = 1
              break
            // 泰国对应泰语
            case 2:
              this.$refs.form[0].form['id_poi_language'] = 2
              break
            // // 菲律宾对应菲律宾语
            // case 3:
            //   this.$refs.form[0].form['id_poi_language'] = 4
            //   break
            // 马来西亚、新加坡对应英语
            case 5:
            case 6: 
              this.$refs.form[0].form['id_poi_language'] = 4
              break
            
          }
        })
      }
    },

    async Submit() {
      let formHasError = false
      let result = {}
      if (Array.isArray(this.$refs.form)) {
        result = this.$refs.form.reduce((finalForm, formData) => {
          let {hasError, form} = formData.getFormData()
          if (hasError) formHasError = hasError
          finalForm = Object.assign(finalForm, form)
          return finalForm
        }, {})
      } else {
        let {hasError, form} = this.$refs.form.getFormData()
        formHasError = hasError
        result = form
      }

      // 最终处理数据
      if (formHasError) return
      console.log('提交之前', result)
      result.id_poi_product = result.product.id
      result.id_poi_users = result.user
      result.payment = JSON.stringify(result.payment)
      let {user, product, ...finalResult} = result
      if (this.viewType === 'add') {
        let res = await this.$api.CreateSite(finalResult)
        this.$router.go(-1)
      } else {
        let res = await this.$api.UpdateSite(finalResult)
        this.$router.go(-1)
      }
    },
    async GetData() {
      this.isLoading = true
      let {id} = this.$route.query
      let res = {
        data: {}
      }
      if (id) {
        res = await this.$api.GetSite(id)
        res.data.user = res.data.id_poi_users
        res.data.product = res.data.sg_product
        res.data.payment = JSON.parse(res.data.payment)
        res.data.sg_packages.map((pkg, index) => {
          pkg.package_product_relation = pkg.sg_package_product_relations
          delete pkg.sg_package_product_relations

          pkg.package_product_relation.map((relation, index) => {
            relation.group_index = index
            relation.attributes = relation.sg_package_product_attribute_relations
            relation.product = relation.sg_product
            delete relation.sg_product
            delete relation.sg_package_product_attribute_relations

            relation.attributes = relation.attributes.map(({id_poi_sku_attribute, id}) => {
              return {
                id,
                group_index: index,
                id_poi_sku_attribute
              }
            })
            return relation
          })  
          return pkg
        })
        res.data.atlas_image = res.data.sg_commodity_imgs
        res.data.package = res.data.sg_packages
        delete res.data.sg_packages
        delete res.data.sg_commodity_imgs
        this.isLoading = false
        console.log('package', res.data.package)
      } 
      this.$store.commit('setDialogValue', res.data)
      this.isLoading = false
    },
    init() {
      this.$store.commit('setViewType', this.$route.meta.viewType)
      this.GetData()
    }
  },
  mounted  () {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/index.less';
.form {
  margin-bottom: 10px;
}

</style>